import React from 'react';
import { Construction, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { cn } from '../lib/utils';

export const UnderConstructionBadge = ({ className }) => (
  <Badge className={cn('rounded-full bg-brand-butter text-brand-deep border border-brand-copper/40 text-[10px] gap-1 animate-pulse', className)} data-testid="under-construction-badge">
    <Construction className="w-3 h-3" /> En construcción
  </Badge>
);

export const UnderConstructionButton = ({ label, detail, testid, className, icon: Icon = Sparkles }) => (
  <Button
    type="button"
    variant="outline"
    data-testid={testid}
    onClick={() => toast(label, { description: detail || 'Estamos conectando esta función. Pronto estará lista.', icon: <Construction className="w-4 h-4" /> })}
    className={cn('relative border-dashed border-brand-copper/60 bg-brand-butter/20 hover:bg-brand-butter/40 text-brand-deep dark:text-brand-butter', className)}
  >
    <span className="absolute -top-2 -right-2 w-2.5 h-2.5 rounded-full bg-brand-copper animate-ping" />
    <span className="absolute -top-2 -right-2 w-2.5 h-2.5 rounded-full bg-brand-copper" />
    <Icon className="w-4 h-4 mr-2" />
    {label}
    <Construction className="w-3.5 h-3.5 ml-2 opacity-70" />
  </Button>
);
